import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import React from 'react';
import Page from 'src/components/Page';
import gradients from 'src/utils/gradients';
import { text } from "../../modules/languages/index";
import LoginForm from './LoginForm';
import logo from 'src/assets/images/konsep_2..png'
const meta = document.createElement('meta');
meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
meta.setAttribute('name', 'viewport');
document.head.appendChild(meta);

const styles = {
  root: (theme) => ({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2)
  }),
  card: (theme) => ({
    width: theme.breakpoints.values.md,
    maxWidth: '100%',
    overflow: 'visible',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%'
    }
  }),
  content: (theme) => ({
    padding: theme.spacing(8, 4, 3, 4)
  }),
  media: (theme) => ({
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(3),
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  }),
  icon: (theme) => ({
    backgroundImage: gradients.green,
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    position: 'absolute',
    top: -32,
    left: theme.spacing(3),
    height: 64,
    width: 64,
    fontSize: 32
  }),
  loginForm: (theme) => ({
    marginTop: theme.spacing(3)
  }),
  divider: (theme) => ({
    margin: theme.spacing(2, 0)
  }),
  person: (theme) => ({
    marginTop: theme.spacing(2),
    display: 'flex'
  }),
  avatar: (theme) => ({
    marginRight: theme.spacing(2)
  })
};

function Login() {
  return (
    <Page
      sx={styles.root}
      title={"Apollo Yönetimi Giriş"}
    >
      <Card sx={styles.card}>
        <CardContent sx={styles.content}>
          <Typography
            gutterBottom
            variant="h3"
          >
            {"Apollo Yönetimi"}
          </Typography>
          <Typography variant="subtitle2">
            {text("Giris_Yapiniz")}
          </Typography>
          <Box sx={styles.loginForm}>
            <LoginForm />
          </Box>
        </CardContent>
        <CardMedia
          sx={styles.media}
          image={logo}
          title="Cover"
        >
          <Typography
            color="inherit"
            variant="subtitle1"
          >
          </Typography>
          <Box sx={styles.person}>
            <div>
              <Typography
                color="inherit"
                variant="body1"
              >
              </Typography>
              <Typography
                color="inherit"
                variant="body2"
              >
              </Typography>
            </div>
          </Box>
        </CardMedia>
      </Card>
    </Page>
  );
}

export default Login;
